import {
  TOrderCheckoutItemProductType,
  TOrderStatusEnum,
  TOrdersGetListBE,
} from 'api/orders/orders.types';

const IMG_A =
  'https://res.cloudinary.com/dnr7ssars/image/upload/v1776116047/phoneCases/xm67wnspnkq2gnywb1qe.jpg';
const IMG_B =
  'https://res.cloudinary.com/dnr7ssars/image/upload/v1776116325/phoneCases/pemmmbiqeqbngtxqjb9t.jpg';

export const ORDERS_GET_LIST_MOCK: TOrdersGetListBE['data'] = {
  items: [
    {
      id: '69e681e912a9db37e0ed2988',
      checkoutItems: [
        {
          price: 77,
          productId: '69dd614f49f1438310510a0e',
          productType: TOrderCheckoutItemProductType.PhoneCase,
          productName: 'phoneCases.69dd614f49f1438310510a0e.name',
          productImage: IMG_A,
          quantity: 1,
          stock: [{ name: 'IPhone 14 Pro Max', variation: 'Black' }],
        },
        {
          price: 77,
          productId: '69dd614f49f1438310510a0e',
          productType: TOrderCheckoutItemProductType.PhoneCase,
          productName: 'phoneCases.69dd614f49f1438310510a0e.name',
          productImage: IMG_A,
          quantity: 1,
          stock: [{ name: 'IPhone 14 Pro Max', variation: 'Transparent' }],
        },
        {
          price: 75,
          productId: '69dd626549f1438310510a5b',
          productType: TOrderCheckoutItemProductType.PhoneCase,
          productName: 'phoneCases.69dd626549f1438310510a5b.name',
          productImage: IMG_B,
          quantity: 1,
          stock: [{ name: 'IPhone 12', variation: 'Transparent MagSafe' }],
        },
      ],
      reservationId: '69e681e912a9db37e0ed2987',
      totalPrice: 229,
      orderNumber: 'ORD-2026-0420-001',
      status: TOrderStatusEnum.InProgress,
      payed: true,
      receiveNotifications: true,
      policyAccepted: true,
      payment: { method: 'card', capturedAt: '2026-04-20T08:20:00.000Z' },
      shippingData: {
        phone: '501234567',
        city: 'Kraków',
        postalCode: '30-001',
        street: 'Floriańska',
        buildingNumber: '12',
        apartamentNumber: '4',
        firstName: 'Jan',
        lastName: 'Kowalski',
        deliveryMethod: 'inpost',
        parcelLockerCode: 'KRA010',
        email: 'jan.kowalski@example.com',
        additionalInfo: null,
      },
      userId: '69dd614f49f1438310510a0f',
      createdAt: '2026-04-20T08:15:00.000Z',
      updatedAt: '2026-04-20T14:22:33.000Z',
    },
    {
      id: '69e681ea12a9db37e0ed2991',
      checkoutItems: [
        {
          price: 99,
          productId: '69dd614f49f1438310510a0e',
          productType: TOrderCheckoutItemProductType.PhoneCase,
          productName: 'phoneCases.69dd614f49f1438310510a0e.name',
          productImage: IMG_A,
          quantity: 1,
          stock: [{ name: 'IPhone 13', variation: 'Blue' }],
        },
      ],
      reservationId: '69e681e912a9db37e0ed2990',
      totalPrice: 99,
      orderNumber: 'ORD-2026-0419-014',
      status: TOrderStatusEnum.Refunded,
      payed: true,
      receiveNotifications: false,
      policyAccepted: true,
      payment: { method: 'card' },
      shippingData: {
        phone: '600111222',
        city: 'Warszawa',
        postalCode: '00-001',
        street: 'Marszałkowska',
        buildingNumber: '100',
        apartamentNumber: '',
        firstName: 'Anna',
        lastName: 'Nowak',
        deliveryMethod: 'kurier',
        parcelLockerCode: '',
        email: 'anna.nowak@example.com',
        additionalInfo: null,
      },
      userId: '69dd626549f1438310510a5c',
      createdAt: '2026-04-19T11:00:00.000Z',
      updatedAt: '2026-04-20T09:05:12.000Z',
    },
    {
      id: '69e681eb12a9db37e0ed2992',
      checkoutItems: [
        {
          price: 77,
          productId: '69dd614f49f1438310510a0e',
          productType: TOrderCheckoutItemProductType.PhoneCase,
          productName: 'phoneCases.69dd614f49f1438310510a0e.name',
          productImage: IMG_A,
          quantity: 1,
          stock: [{ name: 'IPhone 14 Pro Max', variation: 'Black' }],
        },
      ],
      reservationId: '69e681e912a9db37e0ed2992',
      totalPrice: 77,
      orderNumber: 'ORD-2026-0422-003',
      status: TOrderStatusEnum.Created,
      payed: false,
      receiveNotifications: true,
      policyAccepted: true,
      payment: null,
      shippingData: {
        phone: '',
        city: '',
        postalCode: '',
        street: '',
        buildingNumber: '',
        apartamentNumber: '',
        firstName: '',
        lastName: '',
        deliveryMethod: '',
        parcelLockerCode: '',
        email: 'guest@example.com',
        additionalInfo: null,
      },
      userId: '69dd614f49f1438310510a10',
      createdAt: '2026-04-22T09:00:00.000Z',
      updatedAt: '2026-04-22T09:00:00.000Z',
    },
    {
      id: '69e681ec12a9db37e0ed2993',
      checkoutItems: [
        {
          price: 75,
          productId: '69dd626549f1438310510a5b',
          productType: TOrderCheckoutItemProductType.PhoneCase,
          productName: 'phoneCases.69dd626549f1438310510a5b.name',
          productImage: IMG_B,
          quantity: 2,
          stock: [{ name: 'IPhone 12', variation: 'Transparent MagSafe' }],
        },
      ],
      reservationId: '69e681e912a9db37e0ed2993',
      totalPrice: 150,
      orderNumber: 'ORD-2026-0422-004',
      status: TOrderStatusEnum.Payed,
      payed: true,
      receiveNotifications: true,
      policyAccepted: true,
      payment: { method: 'card', intentId: 'pi_mock_01' },
      shippingData: {
        phone: '512000111',
        city: 'Gdańsk',
        postalCode: '80-001',
        street: 'Długa',
        buildingNumber: '5',
        apartamentNumber: '2',
        firstName: 'Piotr',
        lastName: 'Wiśniewski',
        deliveryMethod: 'inpost',
        parcelLockerCode: 'GDA02B',
        email: 'piotr.w@example.com',
        additionalInfo: 'Ring the bell twice',
      },
      userId: '69dd614f49f1438310510a11',
      createdAt: '2026-04-22T10:15:00.000Z',
      updatedAt: '2026-04-22T10:18:00.000Z',
    },
    {
      id: '69e681ed12a9db37e0ed2994',
      checkoutItems: [
        {
          price: 77,
          productId: '69dd614f49f1438310510a0e',
          productType: TOrderCheckoutItemProductType.PhoneCase,
          productName: 'phoneCases.69dd614f49f1438310510a0e.name',
          productImage: IMG_A,
          quantity: 1,
          stock: [{ name: 'IPhone 14 Pro Max', variation: 'Transparent' }],
        },
      ],
      reservationId: '69e681e912a9db37e0ed2994',
      totalPrice: 77,
      orderNumber: 'ORD-2026-0421-005',
      status: TOrderStatusEnum.InDelivery,
      payed: true,
      receiveNotifications: false,
      policyAccepted: true,
      payment: { method: 'card' },
      shippingData: {
        phone: '533444555',
        city: 'Wrocław',
        postalCode: '50-001',
        street: 'Świdnicka',
        buildingNumber: '22',
        apartamentNumber: '',
        firstName: 'Maria',
        lastName: 'Zielińska',
        deliveryMethod: 'dpd',
        parcelLockerCode: '',
        email: 'maria.z@example.com',
        additionalInfo: null,
      },
      userId: '69dd626549f1438310510a5d',
      createdAt: '2026-04-21T07:30:00.000Z',
      updatedAt: '2026-04-22T06:00:00.000Z',
    },
    {
      id: '69e681ee12a9db37e0ed2995',
      checkoutItems: [
        {
          price: 99,
          productId: '69dd614f49f1438310510a0e',
          productType: TOrderCheckoutItemProductType.PhoneCase,
          productName: 'phoneCases.69dd614f49f1438310510a0e.name',
          productImage: IMG_A,
          quantity: 1,
          stock: [{ name: 'IPhone 13', variation: 'Blue' }],
        },
        {
          price: 75,
          productId: '69dd626549f1438310510a5b',
          productType: TOrderCheckoutItemProductType.PhoneCase,
          productName: 'phoneCases.69dd626549f1438310510a5b.name',
          productImage: IMG_B,
          quantity: 1,
          stock: [{ name: 'IPhone 12', variation: 'Black' }],
        },
      ],
      reservationId: '69e681e912a9db37e0ed2995',
      totalPrice: 174,
      orderNumber: 'ORD-2026-0418-006',
      status: TOrderStatusEnum.Done,
      payed: true,
      receiveNotifications: true,
      policyAccepted: true,
      payment: { method: 'card' },
      shippingData: {
        phone: '601222333',
        city: 'Poznań',
        postalCode: '60-001',
        street: 'Półwiejska',
        buildingNumber: '10',
        apartamentNumber: '15',
        firstName: 'Tomasz',
        lastName: 'Lewandowski',
        deliveryMethod: 'kurier',
        parcelLockerCode: '',
        email: 't.lewandowski@example.com',
        additionalInfo: null,
      },
      userId: '69dd614f49f1438310510a12',
      createdAt: '2026-04-18T12:00:00.000Z',
      updatedAt: '2026-04-19T16:45:00.000Z',
    },
  ],
  pagination: {
    page: 1,
    perPage: 10,
    total: 6,
  },
};
